import React from 'react';
import { useTranslation } from 'react-i18next';
import DownArrow from '../../../../../assets/downArrow.svg';
import { DefaultPropertyType } from '../../../../../interface/core';
import { FilterType } from '../../../../../interface';
import { Instances, TimeDropDownOptions } from '../../../../../constants';
import WidgetDropDown from '../../../molecules/DropDown/Dropdown';
import HeaderTemplate from '../../../templates/Header';
// import Hamburger from '../../../molecules/WidgetHamburger';
import DownloadButton from '../../../molecules/Download';

type HeaderPropsType = {
	filters: FilterType;
	account: string;
	showDownload?: boolean;
	onFilterChange: (filters: FilterType) => void;
	setFilterKey: (key: string) => void;
};

const Header: React.FC<HeaderPropsType> = ({
	filters,
	onFilterChange,
	account,
	showDownload,
	setFilterKey
}) => {
	const { t } = useTranslation();

	const getDropdown = (
		options: Array<DefaultPropertyType>,
		onClick?: (data: any) => void,
		selectedItem?: DefaultPropertyType,
		title?: string
	) => (
			<WidgetDropDown
				title={title}
				trigger={'click'}
				placement={'bottom'}
				items={options}
				label={selectedItem?.label}
				icon={<img src={DownArrow} alt="arrow"/>}
				action={onClick}
			/>
		);

	const getTimeLabel = () => {
		const { timerange } = filters || {};
		const { start_time, end_time } = timerange || {};
		return TimeDropDownOptions.find(({ value }) => {
			const [start, end] = value as Array<string>;
			return start_time === start && end === end_time;
		});
	};

	const memoizedTime = React.useMemo(() => getTimeLabel(), [
		filters?.timerange?.end_time,
		filters?.timerange?.start_time,
	]);

	const onTimeRange = ([start, end, key]: Array<string>) => {
		onFilterChange({
			...filters,
			timerange: {
				start_time: start,
				end_time: end,
			},
		});
		setFilterKey(key);
	};

	const getTitle = () => {
		if (showDownload) {
			return t('creditSeeMore');
		} else {
			return account === 'prepaid'
				? t('creditWidgetPrepaidWidget')
				: t('creditWidgetPostpaidWidget');
		}
	};

	return (
		<HeaderTemplate title={getTitle()}>
			{getDropdown(TimeDropDownOptions, onTimeRange, memoizedTime)}
			{/* <Hamburger /> */}
			{showDownload && (
				<DownloadButton
					instanceId={Instances.creditDetailed}
					message={t('creditReportDownload')}
					params={filters}
				/>
			)}
		</HeaderTemplate>
	);
};

export default Header;
